/* unplugin-vue-components disabled */import { render } from "./Menu.vue?vue&type=template&id=562b20c8"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=562b20c8&lang=css"

import exportComponent from "/home/dagger/dagger/dagger-self/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__